export default __webpack_public_path__ + "static/media/OpenSans-Light.ed41bedf.ttf";